<template>
  <div>
    <label class="flex text-gray-700 text-s cursor-pointer">
      <input
        :checked="checked"
        type="checkbox"
        class="mt-2px mr-2"
        @change="$emit('change', $event.target.checked)"
      />
      <span class="leading-tight">
        I have read and agree with the
        <a :href="url" target="_blank" class="text-gray-900 underline"
          ><span class="capitalize">{{ type }}</span> Terms & Conditions</a
        >
      </span>
    </label>
    <span v-if="error" class="block mt-1 text-error text-xs">
      {{ errorMessage }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'LmLegalCheckbox',
  components: {},
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    type: {
      validator(v) {
        return ['user', 'customer'].indexOf(v) >= 0 ? v : false
      },
      default: 'customer'
    },
    checked: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      error: false,
      errorMessage: 'You have to accept the terms'
    }
  },
  computed: {
    url() {
      return (
        'https://landscapemonitor.io/' +
        (this.type === 'user'
          ? 'user-terms-and-conditions'
          : 'customer-terms-and-conditions')
      )
    }
  },
  watch: {
    checked() {
      this.error = false
    }
  },
  methods: {
    validateData() {
      this.error = !this.checked
      return this.checked
    }
  }
}
</script>
